import React from 'react'
import Breadcrumb from '../../../Components/Breadcrumb'
import Card from '../../../Components/Card'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'
import PageLoading from '../../../Components/PageLoading/PageLoading'
const GET_STATS = gql`
  {
    admin_stats {
      admins
      consultants
      u_consultants
      businesses
      u_businesses
      nt_businesses
      support
      o_support
      plans
      transactions
      subscriptions
    }
  }
`

const Home = () => {
  const { loading, error, data } = useQuery(GET_STATS)
  let pageLoading = false
  if (loading) {
    pageLoading = true
  }
  if (error) {
    return (
      <div className="dashform-box">
        <div className="dashform">
          <div className="dashform-intro text-center">
            Well, this is embarrassing. Something went wrong. Please try again later.
          </div>
        </div>
      </div>
    )
  }
  let stats = {}
  if (data) {
    stats = data.admin_stats
  }

  return (
    <>
      {pageLoading ? <PageLoading ripple={true} /> : null}
      <Breadcrumb name="Super-Admin Home" type="admin" />
      <Card
        w="w-1of3"
        h="h-250"
        align="text-center"
        theme="purple"
        icon="user-friends"
        header2={data ? String(stats.admins) : ''}
        header3="Admins"
        header0="Click to view Admins"
        link="/admins"
      />
      <Card
        w="w-1of3"
        h="h-250"
        align="text-center"
        theme="purple"
        icon="users"
        header2={data ? String(stats.consultants) : ''}
        header2min={
          data
            ? String(
                stats.consultants * 20 - (stats.businesses - stats.u_businesses)
              )
            : ''
        }
        header3="Consultants"
        header3min="business slots"
        header0="Click to view Consultants"
        link="/consultants"
      />
      <Card
        w="w-1of3"
        h="h-250"
        align="text-center"
        theme="purple"
        icon="briefcase"
        header2={data ? String(stats.businesses) : ''}
        header2min={data ? String(stats.u_businesses) : ''}
        header3="Businesses"
        header3min="unverified"
        header0="Click to view Businesses"
        link="/businesses"
      />
      <Card
        w="w-1of3"
        h="h-250"
        align="text-center"
        theme="purple"
        icon="comments"
        header2={data ? String(stats.support) : ''}
        header2min={data ? String(stats.o_support) : ''}
        header3="Support"
        header3min="Open"
        header0="Click to view Supports"
        link="/support"
      />
      <Card
        w="w-1of3"
        h="h-250"
        align="text-center"
        theme="purple"
        icon="briefcase"
        header2={data ? String(stats.plans) : ''}
        header2min=""
        header3="Plans"
        header3min=""
        header0="Click to view Plans"
        link="/plans"
      />
      <Card
        w="w-1of3"
        h="h-250"
        align="text-center"
        theme="purple"
        icon="briefcase"
        header2={data ? String(stats.transactions) : ''}
        header2min=""
        header3="Transactions"
        header3min=""
        header0="Click to view all transactions"
        link="/transactions"
      />
      <Card
        w="w-1of3"
        h="h-250"
        align="text-center"
        theme="purple"
        icon="briefcase"
        header2={data ? String(stats.subscriptions) : ''}
        header2min=""
        header3="Subscriptions"
        header3min=""
        header0="Click to view all subscriptions"
        link="/subscriptions"
      />

      <Card
        w="w-1of3"
        h="h-250"
        align="text-center"
        theme="purple"
        icon="file-medical-alt"
        header3="Tax Health Requests"
        // header3min="Open"
        header0="Click to view tax health list"
        link="/tax-health-requests"
      />
      <Card
        w="w-1of3"
        h="h-250"
        align="text-center"
        theme="purple"
        icon="calculator"
        header3="Computation Requests"
        // header3min="Open"
        header0="Click to view computation list"
        link="/tax-computation-requests"
      />
    </>
  )
}

export default Home
